import { forwardRef } from "react";
import { useMediaQuery } from "react-responsive";

import { UiCheckIcon } from "@jti/brand-icons/ui-check";
import { Button } from "@jti/core-components/components/Button";
import { BREAKPOINT_MEDIUM } from "@jti/fe-common";
import type { TextInputProps } from "@jti/ui";
import { InputIcon, TextInput, useTranslations } from "@jti/ui";

import styles from "../../LoyaltyReferralCodeView.module.scss";

export const LoyaltyReferralCodeControls = forwardRef<HTMLInputElement, TextInputProps>(
  ({ disabled, isSuccess, value, ...restInputProps }, ref) => {
    const { __ } = useTranslations();

    const isOverMediumBreakpoint = useMediaQuery({
      query: `(min-width: ${BREAKPOINT_MEDIUM}px)`,
    });

    return (
      <div className={styles.referralControls}>
        <TextInput
          {...restInputProps}
          id="referralCodeInput"
          ref={ref}
          data-testid="referralCodeInput"
          value={value}
          isSuccess={isSuccess}
          label={__("cart.loyalty.referral.form.label")}
          placeholder={__("cart.loyalty.referral.form.placeholder")}
          helperText={__("cart.loyalty.referral.form.helperText")}
          successText={__("cart.loyalty.referral.form.successText")}
          elemAfter={isSuccess ? <InputIcon icon={UiCheckIcon} isSuccess isDisabled /> : undefined}
          readOnly={isSuccess}
          containerClassName={styles.referralInput}
        />
        <Button
          disabled={disabled || !value}
          variant="secondary"
          type="submit"
          size={isOverMediumBreakpoint ? "md" : undefined}
          className={styles.applyButton}
          data-testid="applyReferralCodeButton"
        >
          {__("cart.loyalty.referral.form.submit")}
        </Button>
      </div>
    );
  }
);
